import { ADD_DISCOUNT_MASTER } from "../../types/DiscountMasterType";
import axios from "axios";
import { toast } from "react-toastify";

const addDiscountMasterAction = (data) => {
	return {
		type: ADD_DISCOUNT_MASTER,
		payload: data,
	};
};

export const addDiscountMaster = (values) => {
	return async (dispatch) => {
		try {
            const isArray = Array.isArray(values);
            const url = isArray ? `discount-master/?query=createmany` : `discount-master/`;
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url,
				data: isArray ? values : {
					...values,
				},
			});
			dispatch(addDiscountMasterAction(data));
			toast.success(isArray ? `${data.created} Discount Masters Added` : "Discount Master Added");
			return {
				message: "success",
			};
		} catch (error) {
			toast.error(error.response?.data?.error || "Error in adding discount master");
			console.log(error.message);
		}
	};
};
